import {applySpec, prop, compose, map, lt} from "ramda";
import {buildAvatarSrc} from "../../helpers/buildAvatarSrc";

const Profile = applySpec({
  avatarSrc: compose(buildAvatarSrc, prop("avatar")),
  username: prop("username"),
  email: prop("email"),
});

const Account = applySpec({
  externalId: prop("external_id"),
  accountId: prop("account_id"),
});

const UserPremiumStatus = applySpec({
  isPremium: compose(lt(0), prop("length"), map(prop("benefit"))),
});

export {Profile, Account, UserPremiumStatus};
